import slide1 from "@/assets/images/pages/home/slide-1.jpg";
import slide2 from "@/assets/images/pages/home/slide-2.png";
import slide3 from "@/assets/images/pages/home/slide-3.png";

import duiProgram from "@/assets/images/pages/home/dui-program.png";
import drivingLessons from "@/assets/images/pages/home/driving-lessons.jpg";
import driverTest from "@/assets/images/pages/home/driver-test.jpg";
import onlineTrafficSchool from "@/assets/images/pages/home/online-traffic-school.jpg";
import classroomTrafficSchool from "@/assets/images/pages/home/classroom-traffic-school.jpg";
import workplaceSafety from "@/assets/images/pages/home/workplace-safety.jpg";

import myFlorida from "@/assets/images/pages/home/my-florida.jpg";
import clerk from "@/assets/images/pages/home/clerk.jpg";

export const home = {
  slides: [
    {
      image: slide1,
      line1: "Convenient classes",
      line2: "Traffic School",
      line3: "online or classroom",
      link: "/traffic-school-program",
    },
    {
      image: slide2,
      line1: "Learn to Drive",
      line2: "Driving Lessons",
      line3: "Programs to fit your needs",
      link: "/driving-lessons",
    },
    {
      image: slide3,
      line1: "State Licensed",
      line2: "DUI Program",
      line3: "Provides all required DUI services",
      link: "/dui-school",
    },
  ],
  guarantees: [
    {
      icon: "money-bill",
      iconType: "solid",
      title: "Money back guarantee",
      text: "We are so confident that you will be 100% satisfied that we guarantee it or your money back.",
    },
    {
      icon: "ban",
      iconType: "solid",
      title: "No hidden cost",
      text: "We only advertise our actual bottom line cost. What you see is what you get.",
    },
    {
      icon: "certificate",
      iconType: "solid",
      title: "Certificate Included",
      text: "Other schools charge additional fees to provide a certificate of completion we provide it for free.",
    },
    {
      icon: "heart",
      iconType: "solid",
      title: "Price Match Promise",
      text: "Find a better deal? Just send us a message with information about the advertised price and we'll give you a discount.",
    },
  ],
  cards: [
    {
      title: "DUI Program",
      text: "State-licensed program provides the required DUI services to court-ordered and voluntary drivers in FL.",
      imgSrc: duiProgram,
      link: "/dui-school",
    },
    {
      title: "Driving Lessons",
      text: "Learn to drive with Metro Driving School. We have Florida driving lessons that fit your needs.",
      imgSrc: drivingLessons,
      link: "/driving-lessons",
    },
    {
      title: "Driver Test",
      text: "No need to wait in line at the DMV! Take your Florida DMV Permit Test ONLINE!",
      imgSrc: driverTest,
      link: "/florida-driving-test",
    },
    {
      title: "Online Traffic School",
      text: "Complete our FL Driving school online course at your own pace, on your own schedule.",
      hasAudioSample: true,
      imgSrc: onlineTrafficSchool,
      link: "/online-traffic-school",
    },
    {
      title: "Classroom Traffic School",
      text: "For students who are interested in an interactive course with a “live” instructor in a classroom setting.",
      imgSrc: classroomTrafficSchool,
      link: "/classroom-traffic-school",
    },
    {
      title: "Workplace Safety",
      text: "Programs to prevent the personal and economic loss associated with accidents and health hazards.",
      imgSrc: workplaceSafety,
      link: "http://www.metrofloridasafetycouncil.com/",
      target: "_blank",
    },
  ],
  reviews: [
    {
      name: "Mark Gonzales",
      email: "robbi914@att.net",
      message: "It was quick",
      initial_comments: "It was quick",
      rating: 5,
      review_date: "October 14, 2025",
      review_location: ", United States",
    },
    {
      name: "Ernest Hale",
      email: "chale4748@gmail.com",
      message: "smooth and easy",
      initial_comments: "smooth and easy",
      rating: 5,
      review_date: "October 14, 2025",
      review_location: ", United States",
    },
    {
      name: "Andre Smith",
      email: "gogeta2008@netzero.com",
      message: "easy way to sign up",
      initial_comments: "easy way to sign up",
      rating: 5,
      review_date: "October 14, 2025",
      review_location: ", United States",
    },
    {
      name: "Robert Ivanoff",
      email: "robert.ivanoff@icloud.com",
      message: "quick and easy",
      initial_comments: "quick and easy",
      rating: 5,
      review_date: "October 13, 2025",
      review_location: "Florida, United States",
    },
    {
      name: "Robert Xavier",
      email: "xavierfl@aol.com",
      message: "I am not a good computer operator and needed help",
      initial_comments: "I am not a good computer operator and needed help",
      rating: 5,
      review_date: "October 13, 2025",
      review_location: ", United States",
    },
    {
      name: "Videline Guerrier",
      email: "videlineg@gmail.com",
      message: "It was easy to choose class and easy to make payments online.",
      initial_comments:
        "It was easy to choose class and easy to make payments online.",
      rating: 5,
      review_date: "October 13, 2025",
      review_location: ", United States",
    },
    {
      name: "Bernard Cost",
      email: "berniecost@gmail.com",
      message: "ok so far",
      initial_comments: "ok so far",
      rating: 5,
      review_date: "October 12, 2025",
      review_location: "Florida, United States",
    },
    {
      name: "JASMINE",
      email: "jazzyfrazier11@gmail.com",
      message: "GOOD SOUP",
      initial_comments: "GOOD SOUP",
      rating: 3,
      review_date: "October 12, 2025",
      review_location: "Florida, United States",
    },
    {
      name: "Aicha ezzaiym",
      email: "aichazaim4011@icloud.com",
      message: "Great service",
      initial_comments: "Great service",
      rating: 5,
      review_date: "October 12, 2025",
      review_location: ", United States",
    },
    {
      name: "Vivi A",
      email: "viviaubret@gmail.com",
      message:
        "Easy to use, fast certification process! Definitely I would recommend it!",
      initial_comments: null,
      rating: 5,
      review_date: "October 10, 2025",
      review_location: "FL, United States",
    },
  ],
  partners: [
    {
      name: "MyFlorida",
      logoUrl: myFlorida,
      link: "https://www.myflorida.gov",
    },
    {
      name: "Clerks of Court",
      logoUrl: clerk,
      link: "https://dos.fl.gov/library-archives",
    },
  ],
  paragraph: {
    text: "<p>Metro Traffic School is approved by the State of Florida and the Department of Highway Safety &amp; Motor Vehicles to offer a variety of programs, such as the 4-Hour New Driver (Drug and Alcohol course), DMV Permit Test, Behind the Wheel Training (Driving Lessons), Traffic School courses for traffic tickets and suspended driver’s licenses, and lastly Driving Under the Influence (DUI).</p>\r\n                    <p>Becoming a Better Driver is easy with Metro Traffic School’s help.</p>\r\n                    <p>Metro Traffic School offers our students the ability to complete all required courses to meet their Florida Traffic School requirements. Our highly trained and experienced professionals will assist students in making informed decisions with regard to their Florida Traffic School course. Our programs are designed to fit each student’s individual needs through either a classroom or online course. Metro Traffic School is committed to delivering excellence in Traffic Safety education.</p>             \r\n                    <p>Our courses will prepare you to get behind the wheel with confidence, help you become a safer driver, avoid points or complete your requirements to get back on the road after a DUI arrest. If you received a traffic ticket for speeding or any other moving violation and you complete our 4 hour Florida Online Traffic School course you will save money on your insurance (Florida Statute 626.9541), keep points off your driving record, and maintain your safe driver status.</p><p>The principal goal and mission of Metro Traffic School is to enable students to improve driving skills, and in turn, make our streets a safer place for all drivers to share.</p>",
  },
};
